export const BUTTONS_TYPE = {
  INLINE: 'inline',
  STACKED: 'stacked',
};
